import { IAppConfig } from './IAppConfig';

import { Reservation } from '../../api/model/reservation/reservation.model';
import { User } from '../../api/model/user/user.model';
import { ReservationChangeType } from '../../api/model/reservation/change/reservation-change.model';
import { Hotel } from '../../api/model/hotel/hotel.model';
import { ReservationStayPreferences } from '../../api/model/reservation/stay-preferences/reservation-stay-preferences.model';
import { AccountStayPreferences } from '../../api/model/user/stay-preferences/stay-preference.model';
import { FeatureFlags } from '../../api/model/featureflags/feature-flags.model';
import { AnyAction } from 'redux';
import { EarningsEstimate } from '../../api/model/reservation/points-estimate';
import { IResDirectNumber, Translation, IMessage } from '../../api/interfaces';

export enum AppAction {
  APP_LOAD = 'APP_LOAD',
  GET_RESERVATION = 'GET_RESERVATION',
  GET_HOTEL = 'GET_HOTEL',
  GET_MEMBER = 'GET_MEMBER',
  CHANGE_MEMBER_STATUS = 'CHANGE_MEMBER_STATUS',
  GET_FEATURE_FLAGS = 'GET_FEATURE_FLAGS',
  GET_STAY_PREFERENCES = 'GET_STAY_PREFERENCES',
  MODIFY_STAY_PREFERENCES = 'MODIFY_STAY_PREFERENCES',
  GET_ACCOUNT_STAY_PREFERENCES = 'GET_ACCOUNT_STAY_PREFERENCES',
  MODIFY_ACCOUNT_STAY_PREFERENCES = 'MODIFY_ACCOUNT_STAY_PREFERENCES',
  CANCEL_RESERVATION = 'CANCEL_RESERVATION',
  MODIFY_RESERVATION = 'MODIFY_RESERVATION',
  ASSOCIATE_RESERVATION = 'ASSOCIATE_RESERVATION',
  JOIN_ASSOCIATE_RESERVATION = 'JOIN_ASSOCIATE_RESERVATION',
  UPDATE_CHANGES = 'UPDATE_CHANGES',
  LOAD_CHANGES = 'LOAD_CHANGES',
  CLEAR_CHANGES = 'CLEAR_CHANGES',
  CLEAR_ALL_CHANGES = 'CLEAR_ALL_CHANGES',
  CHECK_AVAILABILITY = 'CHECK_AVAILABILITY',
  ADD_ADDITIONAL_GUEST_NAMES = 'ADD_ADDITIONAL_GUEST_NAMES',
  GET_POINTS_ESTIMATE = 'GET_POINTS_ESTIMATE',
  GET_ME = 'GET_ME',
  GET_TRANSLATIONS = 'GET_TRANSLATIONS',
  ACCEPT_TERMS = 'ACCEPT_TERMS',
  SAVE_TO_PROFILE = 'SAVE_TO_PROFILE',
  GET_RESDIRECT = 'GET_RESDIRECT',
  ADD_MESSAGE = 'ADD_MESSAGE',
  APPCONFIG_BOOTSTRAP = 'APPCONFIG_BOOTSTRAP',
  GET_RATE_DETAILS = 'GET_RATE_DETAILS',
}

export enum AppActionState {
  INITIAL = 'INITIAL',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

//  import domain models
export interface IAppState {
  state: AppActionState,
  actionType: AppAction,
  error: any,
  resDirect: IResDirectNumber,
  appConfig: IAppConfig,
  acceptTerms: boolean,
  saveToProfile: boolean,
  me: any,
  translations: Translation,
  messages: IMessage[],
  reservation: Reservation,
  hotel: Hotel,
  stayPreferences: ReservationStayPreferences,
  accountStayPreferences: AccountStayPreferences,
  reservationChanges: Map<ReservationChangeType, any>,
  availableReservation: Reservation,
  member: User,
  earningsEstimate: EarningsEstimate,
  featureFlags: FeatureFlags,
  rateDetails: any
}

export interface IAppAction extends AnyAction {
  type: AppAction,
  state?: AppActionState,
  error?: any
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/store/interfaces/IAppState.ts